<template>
  <div style="border-bottom: 1px solid #dadada; margin-bottom: 30px;">
    <form>
      <div
        :class="{ 'border-edit': isSaveEnabled }"
        class="">
        <!-- IS AUTHOR OWNER START -->
        <div class="form-group form-group--author__no-padding-and-border">
          <div class="form-label">
            <label class="control-label">この著作者はアカウント管理者本人ですか？
              <span class="req">＊</span>
            </label>
            <i
              v-tooltip="pcTooltipConfig(tooltipMessages.is_owner)"
              class="tooltip-icon">
            </i>
          </div>
          <div
            class="form-item-inline mr-0">
            <div class="radio">
              <label :for="'owner_yes' + index">
                <input
                  :id="'owner_yes'+index"
                  v-model="authorForm.author_meta.is_owner"
                  :value="true"
                  :disabled="isRadioDisabled"
                  name="owner"
                  type="radio"
                  @click="onIsOwnerChange(index, true)">
                <div
                  :class="{ 'disabled-radio': isRadioDisabled }"
                  class="option-input">
                </div>
                <span>はい</span>
              </label>
            </div>
            <div class="radio">
              <label :for="'owner_no' + index">
                <input
                  :id="'owner_no'+index"
                  v-model="authorForm.author_meta.is_owner"
                  :value="false"
                  :disabled="isRadioDisabled"
                  name="owner"
                  type="radio"
                  @click="onIsOwnerChange(index, false)">
                <div
                  :class="{ 'disabled-radio': isRadioDisabled }"
                  class="option-input">
                </div>
                <span>いいえ</span>
              </label>
            </div>
          </div>
        </div>
        <!-- IS AUTHOR OWNER END -->
        <template
          v-if="!hideRole">
          <author-role
            :author="authorForm"
            :index="index"
            :is-confirm="isCheckboxDisabled"
            :is-instrumental="isInstrumental"
            @update="handleRoleUpdate" />
          <p
            v-if="errors[`authors.${index}.pivot.author_roles`]"
            class="error-text">
            {{ errors[`authors.${index}.pivot.author_roles`][0] }}
          </p>
        </template>
        <div class="form-group form-group--author__no-padding-and-border group-name-checkbox">
          <div class="form-label custom-width">
            <label class="control-label">
              グループ名義で設定する
              <i
                v-tooltip="pcTooltipConfig(tooltipMessages.is_group)"
                class="tooltip-icon"
                style="margin-top: 2px">
              </i>
            </label>
          </div>
          <div
            class="form-item">
            <div class="checkbox">
              <label :for="'is_group' + index">
                <input
                  :id="'is_group'+index"
                  v-model="authorForm.author_meta.is_group"
                  :disabled="showDisabled"
                  :name="'is_group' + index"
                  :value="authorForm.author_meta.is_group"
                  type="checkbox"
                  @change="isAsGroup()" />
                <div
                  :class="{ 'disabled-checkbox': showDisabled }"
                  class="option-input" />
              </label>
            </div>
          </div>
        </div>
        <div class="form-group form-group--author">
          <div class="form-label form-label--author">
            <label
              :for="`author.${index}.name_ja`"
              class="control-label">著作者公表名
              <span class="req">＊</span>
            </label>
            <i
              v-tooltip="pcTooltipConfig(tooltipMessages.author_name_ja)"
              class="tooltip-icon">
            </i>
          </div>
          <div
            class="form-item">
            <input
              :id="`author.${index}.name_ja`"
              v-model.trim="authorForm.name_ja"
              :disabled="isDisableFieldNameJa"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_ja')">
            <p
              v-if="errors[`auth.${index}.name_ja`]"
              class="error-text">
              {{ errors[`auth.${index}.name_ja`][0] }}
            </p>
          </div>
        </div>
        <div class="form-group form-group--author">
          <div class="form-label form-label--author">
            <label
              :for="`author.${index}.name_kana`"
              class="control-label">
              著作者公表名（カナ表記）
              <span class="req">＊</span>
            </label>
          </div>
          <div class="form-item">
            <input
              :id="`author.${index}.name_kana`"
              v-model.trim="authorForm.name_kana"
              :disabled="isDisableFieldNameKana"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_kana')">
            <p
              v-if="errors[`auth.${index}.name_kana`]"
              class="error-text">
              {{ errors[`auth.${index}.name_kana`][0] }}
            </p>
          </div>
        </div>
        <div class="form-group form-group--author">
          <div class="form-label form-label--author">
            <label
              :for="`author.${index}.name_en`"
              class="control-label">
              著作者公表名（アルファベット表記）
              <span class="req">＊</span>
            </label>
          </div>
          <div class="form-item">
            <input
              :id="'author_name_en' + index"
              v-model.trim="authorForm.name_en"
              :disabled="isDisableFieldNameEn"
              class="form-control"
              type="text"
              @blur="onFieldChanged('name_en')">
            <p
              v-if="errors[`auth.${index}.name_en`]"
              class="error-text">
              {{ errors[`auth.${index}.name_en`][0] }}
            </p>
          </div>
        </div>
        <div
          v-if="!authorForm.author_meta.is_owner"
          class="form-group form-group--author">
          <div class="form-label form-label--author">
            <label
              :for="`author.${index}.author_meta.email`"
              class="control-label">
              著作者メールアドレス
              <span class="req">＊</span>
            </label>
          </div>
          <div class="form-item">
            <input
              :id="`author.${index}.author_meta.email`"
              v-model.trim="authorForm.author_meta.email"
              :disabled="showDisabled"
              class="form-control"
              type="text"
              @blur="onFieldChanged('author_meta.email')">
            <p
              v-if="errors[`auth.${index}.author_meta.email`]"
              class="error-text">
              {{ errors[`auth.${index}.author_meta.email`][0] }}
            </p>
          </div>
        </div>
        <div v-if="groupMetaEmpty">
          <div class="form-group form-group--author">
            <div class="form-label form-label--author">
              <label
                :for="`author.${index}.real_name_ja_name`"
                class="control-label">著作者実名
                <span class="req">＊</span>
              </label>
            </div>
            <div
              class="form-item">
              <input
                :id="`author.${index}.real_name_ja_name`"
                v-model.trim="authorForm.author_meta.personal_meta.real_name.ja.name"
                :disabled="showDisabled"
                class="form-control"
                type="text"
                @blur="onFieldChanged('author_meta.personal_meta.real_name.ja.name')">
              <p
                v-if="errors[`auth.${index}.author_meta.personal_meta.real_name.ja.name`]"
                class="error-text">
                {{ errors[`auth.${index}.author_meta.personal_meta.real_name.ja.name`][0] }}
              </p>
            </div>
          </div>
          <div class="form-group form-group--author">
            <div class="form-label form-label--author">
              <label
                :for="'artist_name_en_name' + index"
                class="control-label">著作者実名（アルファベット表記）
                <span class="req">＊</span>
              </label>
            </div>
            <div
              class="form-item">
              <input
                :id="`author.${index}.real_name_en_name`"
                v-model.trim="authorForm.author_meta.personal_meta.real_name.en.name"
                :disabled="showDisabled"
                class="form-control"
                type="text"
                @blur="onFieldChanged('author_meta.personal_meta.real_name.en.name')">
              <p
                v-if="errors[
                  `auth.${index}.author_meta.personal_meta.real_name.en.name`]"
                class="error-text">
                {{ errors[
                  `auth.${index}.author_meta.personal_meta.real_name.en.name`][0] }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="authorForm.author_meta.is_group">
          <div
            v-for="(item, mIndex) in authorForm.author_meta.group_meta"
            :key="mIndex">
            <div class="form-group form-group--author">
              <div class="form-label form-label--author">
                <label
                  :for="'member_ja_name'+ mIndex"
                  class="control-label">メンバー{{ mIndex + 1 }}実名
                  <span class="req">＊</span>
                </label>
              </div>
              <div
                class="form-item">
                <input
                  :id="`member.${mIndex}.real_name_ja_name`"
                  v-model.trim="item.real_name.ja.name"
                  :disabled="showDisabled"
                  class="form-control"
                  type="text"
                  @blur="onFieldChanged(
                    `author_meta.group_meta.${mIndex}.real_name.ja.name`)">
                <p
                  v-if="errors[
                    `auth.${index}.author_meta.group_meta.${mIndex}.real_name.ja.name`]"
                  class="error-text">
                  {{ errors[
                    `auth.${index}.author_meta.group_meta.${mIndex}.real_name.ja.name`
                  ][0] }}
                </p>
              </div>
            </div>
            <div class="form-group form-group--author">
              <div class="form-label form-label--author">
                <label
                  :for="'member_en_name'+ mIndex"
                  class="control-label">メンバー{{ mIndex + 1 }}実名（アルファベット表記）
                  <span class="req">＊</span>
                </label>
              </div>
              <div
                class="form-item">
                <input
                  :id="`member.${mIndex}.real_name_en_name`"
                  v-model.trim="item.real_name.en.name"
                  :disabled="showDisabled"
                  class="form-control"
                  type="text"
                  @blur="onFieldChanged(
                    `author_meta.group_meta.${mIndex}.real_name.en.name`)">
                <p
                  v-if="errors[
                    `auth.${index}.author_meta.group_meta.${mIndex}.real_name.en.name`]"
                  class="error-text">
                  {{ errors[
                    `auth.${index}.author_meta.group_meta.${mIndex}.real_name.en.name`
                  ][0] }}
                </p>
              </div>
            </div>
            <div
              :class="authorForm.author_meta.group_meta.length > 2
                || authorForm.author_meta.group_meta.length - 1 === mIndex
                ? 'form-group-wrap__btn-wrap' : ''">
              <button
                v-if="authorForm.author_meta.group_meta.length - 1 === mIndex &&
                  !showDisabled &&
                  authorForm.author_meta.group_meta.length < 100"
                class="c-btn-author-delete"
                type="button"
                @mousedown="handleButtonMousedown"
                @click.prevent="onMemberAddClicked">
                <span class="mdi mdi-plus-box icon-style"></span>
                追加
              </button>
              <button
                v-if="authorForm.author_meta.group_meta.length > 2 && !showDisabled"
                class="c-btn-author-delete"
                type="button"
                @mousedown="handleButtonMousedown"
                @click.prevent="onMemberDeleteClicked(mIndex)">
                <span class="mdi mdi-minus-box icon-style"></span>
                削除
              </button>
            </div>
          </div>
        </div>
        <!-- IS JASRAC MEMBER -->
        <div
          v-if="!authorForm.author_meta.is_group"
          class="form-group form-group--author__no-padding-and-border">
          <div class="form-label">
            <label class="control-label">
              JASRACメンバーですか？<br>
              (海外著作権団体のメンバーですか？)
            </label>
          </div>
          <div
            class="form-item-inline mr-0">
            <div class="radio">
              <label :for="'jasrac_member_yes' + index">
                <input
                  :id="'jasrac_member_yes'+index"
                  v-model="authorForm.author_meta.personal_meta.is_jasrac_member"
                  :value="true"
                  :disabled="isRadioDisabled"
                  name="jasracMember"
                  type="radio"
                  @click="onIsJasracMemberChange(index, true)">
                <div
                  :class="{ 'disabled-radio': isRadioDisabled }"
                  class="option-input">
                </div>
                <span>はい</span>
              </label>
            </div>
            <div class="radio">
              <label :for="'jasrac_member_no' + index">
                <input
                  :id="'jasrac_member_no'+index"
                  v-model="authorForm.author_meta.personal_meta.is_jasrac_member"
                  :value="false"
                  :disabled="isRadioDisabled"
                  name="jasracMember"
                  type="radio"
                  @click="onIsJasracMemberChange(index, false)">
                <div
                  :class="{ 'disabled-radio': isRadioDisabled }"
                  class="option-input">
                </div>
                <span>いいえ</span>
              </label>
            </div>
          </div>
        </div>
        <!-- IS JASRAC MEMBER -->
        <div
          class="c-btn-wrap">
          <button
            v-if="showCancel"
            class="c-btn c-btn--cancel b-1"
            @mousedown="handleButtonMousedown"
            @click.prevent="$emit('notify-cancel', index)">
            キャンセル
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </button>
          <button
            v-if="showEdit"
            :class="{ 'c-btn--off' : !showEdit }"
            class="c-btn b-1"
            @click.prevent="$emit('notify-edit', index)">
            編集
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </button>
          <button
            :class="{ 'c-btn--off' : !isSaveEnabled }"
            :disabled="!isSaveEnabled"
            class="c-btn b-1"
            @click.prevent="onSaveClicked()">
            保存
            <span class="c-btn__icon-arrow"></span>
          </button>
          <button
            v-if="showRemove"
            class="c-btn c-btn--delete-large b-1"
            @click.prevent="$emit('notify-remove', { data: authorForm, belongsTo: belongsTo })">
            削除
          </button>
        </div>
        <p
          v-if="isSaveEnabled || (isSaveEnabled && isEditTrack)"
          class="error-text">
          ※必要な著作者情報を入力して、「保存」ボタンを押してください。
        </p>
      </div>
    </form>
    <confirm-dialog
      name="delete"
      :is-shown="showConfirmSaveDialog"
      title="著作者情報の保存"
      default-button-title="保存する"
      cancel-button-title="編集へ戻る"
      @closed="showConfirmSaveDialog = false"
      @default-clicked="proceedSave()"
      @cancel-clicked="showConfirmSaveDialog = false">
      <template #body>
        一度保存された著作者公表名は編集できません。<br />
        内容をご確認の上保存してください。
      </template>
    </confirm-dialog>
  </div>
</template>
<script>
import { AUTHOR } from '../consts'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import AuthorRole from './AuthorRole'
import tooltipMessages from '../copyright-tooltips'
import tooltip from '../../../mixins/tooltip'

let aTimer = null
export default {
  name: 'AuthorNew',
  components: {
    AuthorRole,
    ConfirmDialog,
  },
  mixins: [
    tooltip,
  ],
  props: {
    create: {
      type: Boolean,
      default: true,
    },
    hideRole: {
      type: Boolean,
      default: false,
    },
    isEditTrack: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: -1,
    },
    authorForm: {
      type: Object,
      default: () => {},
    },
    authorErrors: {
      type: Object,
      default: () => {},
    },
    belongsTo: {
      type: String,
      default: AUTHOR,
    },
    formValidated: {
      type: Boolean,
      default: false,
    },
    isInstrumental: {
      type: Boolean,
      default: false,
    },
    tooltipMessages: {
      type: Object,
      default: () => tooltipMessages,
    },
  },
  data() {
    return {
      errors: { ...this.authorErrors },
      isValid: this.formValidated,
      showConfirmSaveDialog: false,
    }
  },
  computed: {
    groupMetaEmpty() {
      return this.authorForm.author_meta.group_meta.length === 0
    },
    showRemove() {
      return this.authorForm.operation?.enableRemoveBtn
    },
    showEdit() {
      return this.authorForm.operation?.enableEditBtn
    },
    showCancel() {
      return this.authorForm.operation?.enableCancelBtn
    },
    showDisabled() {
      return this.authorForm.operation?.inputFieldsDisabled
    },
    isSaveEnabled() {
      return this.authorForm.operation?.allowSaveBtn
    },
    isDisableFieldNameJa() {
      return this.authorForm.operation?.disableFieldNameJa
    },
    isDisableFieldNameKana() {
      return this.authorForm.operation?.disableFieldNameKana
    },
    isDisableFieldNameEn() {
      return this.authorForm.operation?.disableFieldNameEn
    },
    isCheckboxDisabled() {
      return this.authorForm.operation?.checkboxDisabled
    },
    isRadioDisabled() {
      return this.authorForm.operation?.radioDisabled
    },
  },
  watch: {
    authorErrors(newErrors) {
      this.errors = { ...newErrors }
    },
    formValidated(newValue) {
      this.isValid = newValue
    },
  },
  methods: {
    handleButtonMousedown(event) {
      event.preventDefault()
    },
    onFieldChanged(key = '') {
      if (aTimer) {
        clearTimeout(aTimer)
      }
      aTimer = setTimeout(() => { this.onAuthorFormSubmit(key) }, 500)
    },
    isAsGroup() {
      if (this.authorForm.author_meta.is_group) {
        const member1 = {
          real_name: {
            ja: { name: '' },
            en: { name: '' },
          },
        }

        const member2 = {
          real_name: {
            ja: { name: '' },
            en: { name: '' },
          },
        }

        this.authorForm.author_meta.group_meta = [member1, member2]
        this.authorForm.author_meta.personal_meta = {}
      } else {
        this.authorForm.author_meta.personal_meta = {
          real_name: {
            ja: { name: '' },
            en: { name: '' },
          },
          is_jasrac_member: false,
        }
        this.authorForm.author_meta.group_meta = []
      }
      const patternToDelete = 'author_meta'
      Object.keys(this.errors).forEach(key => {
        if (key.startsWith(patternToDelete)) {
          delete this.errors[key]
        }
      })
    },

    onAuthorFormSubmit(key = null) {
      this.$emit('notify-save', {
        data: this.authorForm, belongsTo: this.belongsTo, formKey: key, currIndex: this.index,
      })
    },

    onMemberDeleteClicked(index) {
      this.authorForm.author_meta.group_meta.splice(index, 1)
    },

    onMemberAddClicked() {
      this.authorForm.author_meta.group_meta.push(
        {
          real_name: {
            ja: { family_name: '', given_name: '' },
            en: { given_name: '', family_name: '' },
          },
        },
      )
    },

    onSaveClicked() {
      if (Object.keys(this.authorErrors).length === 0 && this.isValid) {
        this.showConfirmSaveDialog = true
        return
      }
      this.onAuthorFormSubmit()
    },

    proceedSave(key = null) {
      this.showConfirmSaveDialog = false
      this.$emit('notify-save', {
        data: this.authorForm, belongsTo: this.belongsTo, formKey: key, currIndex: this.index,
      })
    },
    onIsOwnerChange(index, value) {
      this.$emit('notify-value-update', { field: 'is_owner', index, value })
    },
    onIsJasracMemberChange(index, value) {
      this.$emit('notify-value-update', {
        field: 'is_jasrac_member',
        index,
        value,
        belongsTo: 'personal_meta',
      })
    },
    handleRoleUpdate({ index, role }) {
      this.$emit('notify-role-update', { index, role })
    },
  },
}
</script>
<style scoped>
.disabled-checkbox::before, .disabled-checkbox::after {
  background-color: #c0c0c0;
}
.custom-width {
  top: 2px;
  width: 195px !important;
}

.b-1 {
  margin-bottom: 2%;
}
.border-edit {
  border-color: #ff2289;
  background-color: white;
}
.checkbox {
  display: flex;
}
.c-btn--cancel {
  background-color: #bcb7b3;
}
.mr-0 {
  margin-right: 0 !important;
}
.disabled-radio::before {
  background-color: #c0c0c0;
}
.disabled-radio::after {
  background-color: #c0c0c0;
}

.c-btn-author-delete {
    padding: 8px 30px;
    border-radius: 5px;
}

.form-group-wrap__btn-wrap {
  text-align: end;
}

@media screen and (max-width: 895px) {
  .group-name-checkbox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 10px;
  }
  .radio label span {
    font-size: 17px;
  }
}
</style>
